import { styx } from "modules/Utils";
import { clsx } from "modules/Utils";
import { CSSProperties, useContext } from "react";
import blurGraph from "assets/images/ui/blur-graph.png";
import impactBlurredCountries from "assets/images/campaignDetails/impactBlurredCountries.png";
import impactBlurredDemographics from "assets/images/campaignDetails/impactBlurredDemographics.png";
import ButtonSymphony from "./ButtonSymphony";
import { UpgradeModalContext } from "Hooks/UpgradeModalContext";
import Icon from "./Icon";
import { PlanType } from "modules/Const";
import Colors from "modules/Colors";

interface BlurredGraphProps {
    className: string;
    style?: CSSProperties;
    graph?: string | null | 'topCountries' | 'topDemographics';
    title?: string;
    isHideButton?: boolean;
    buttonText?: string;
    upgradeSource?: string;
    isButton?: boolean;
}

const BlurredGraph = ({
    className,
    style,
    graph,
    title,
    isHideButton = false,
    buttonText = "Upgrade to Pro",
    upgradeSource = "Unlock Data Banner in Campaign Details",
    isButton = true,
}: BlurredGraphProps) => {
    const { handleOpenModal } = useContext(UpgradeModalContext);

    const starsIcon = <Icon className="unlockDataBannerButtonIconLeft" icon="stars" color="white" size={20} />

    const getGraphImage = () => {
        switch (graph) {
            case 'topCountries':
                return impactBlurredCountries;
            case 'topDemographics':
                return impactBlurredDemographics;
            default:
                return blurGraph;
        }
    }

    return (
        <div
            className={clsx('blurredGraphElement', className)}
            style={styx(
                sty.blurredGraphElement,
                style
            )}
        >
            <img
                className={clsx('blurredGraphImage', className)}
                style={styx(
                    sty.blurredGraphImage,
                    style
                )}
                src={getGraphImage()}
            />
            {!isHideButton &&
                <div
                    className="blurredGraphButtonContainer"
                    style={sty.blurredGraphButtonContainer}
                >
                    {title &&
                        <div className="blurredGraphButtonTitle">
                            {title}
                        </div>
                    }
                    {isButton &&
                        <ButtonSymphony
                            className="unlockDataBannerButton"
                            onClick={() => handleOpenModal({
                                source: upgradeSource,
                                highlightedPlan: PlanType.PRO
                            })}
                            iconLeft={starsIcon}
                            iconRight={
                                <div style={{ transform: "scaleX(-1)" }}>
                                    {starsIcon}
                                </div>
                            }
                        >
                            {buttonText}
                        </ButtonSymphony>
                    }
                </div>
            }
        </div>
    )
}

const sty: Record<string, CSSProperties> = {
    blurredGraphElement: {
        width: '100%',
        position: 'relative',
    },
    blurredGraphImage: {
        width: '100%',
    },
    blurredGraphButtonContainer: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        maxWidth: 200,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        textAlign: 'center',
        color: Colors.greyDark,
    }
}

export default BlurredGraph;